// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__1657v"};